import { Pagination } from 'swiper/modules';

import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';

const comments = [
  {
    id: 1,
    name: 'عماد موسوی-یزد',
    comment: 'خرداد 1401',
    text: 'سلام. من 34 تا تابلو گرفتم. برای کافه خواستم افتتاح کنم تو یزد. خیلی از مشاوره راضی بودم. فضایی که میخواستم رو ویدئو گرفتم فرستادم براشون سه تا پروپوزال فرستادن و بیش از صد تا تابلو پیشنهاد دادن که من 34 تا انتخاب کردم و بعد که رسید بسیار بسیار راضی بودم.',
  },
  {
    id: 2,
    name: "امیدوار- مشهد",
    comment: 'اسفند 1399',
    text: 'تابلو طوفان مسیح گرفتم با پاسپارتو سفید و قاب سفید. چاپ و قاب خوب بود.',
  },
  {
    id: 3,
    name: "سحر ابراهیمی- تهران",
    comment: "فروردین 1403",
    text: 'سلام من بار سومه از تونالیته خرید کردم. بسیار تیم حرفه ای داره. ممنون. شب پرستاره ونگوگ، یه کار از فردریش و نیلوفر آبی مونه رو تا الان سفارش دادم. حتما باز سفارش خواهم داد.',
  },
  {
    id: 4,
    name: "کالای تزئینی شریعتی",
    comment: "اسفند 1402",
    text: 'بیش از شش سال هست که برای مغازه لوکس فروشی دارم از تونالیته کار میگیرم. خیلی حرفه ای و راضی کننده هست. شخصا تا الان به چند نفر تو صنف معرفی کردم. کلا بچه های خوبین و کارشون درسته و پیشنهاد میکنم. ',
  },
  {
    id: 5,
    name: 'ارسلان کشتکار',
    comment: 'شیراز- آبان 1400',
    text: 'سایت خیلی حرفه ای طراحی شده. من که تحت تاثیر قرار گرفتم. بسیار کاربری خوب واقعا بین المللی. شش تا تابلو گرفتم و به موقع رسید و رنگ‌ها و چاپ خیلی دقیق بود. تجربه خرید خوبی داشتم. ',
  },
  {
    id: 6,
    name: 'دهقان',
    comment: 'تهران- مهر 1402',
    text: 'دوستان معرفی کردند و نقاشی خط گرفتم سایز بزرگ. خوب بسته بندی کرده بودند و کاملا سالم رسید دستم. مجموعا باید بگم راضیم. ',
  },
  {
    id: 7,
    name: "محمد ساروی",
    comment: "آمل- تیر 1403",
    text: 'تا الان چهار تا تابلو گرفتم از تونالیته. از همه هم راضی بودم. رو پارچه کنواس سفارش دادم. مشاوره هم گرفتم. حتما پیشنهاد میکنم از مشاوره استفاده کنین. برام پی دی اف فرستادن با توضیحات کامل.  رنگها و بافت پارچه خیلی خوبه. پیشنهاد میکنم',
  },
  {
    id: 8,
    name: "امید",
    comment: "تهران- آبان 1402",
    text: 'سایت خوب تیم حرفه‌ای. شخصا خوشحالم که این سایت تو زبان فارسی هست. ندیده بودم قبلا. یه تابلو فرستادم که خودشون فایل با کیفیت رو داشتن چاپ کردند البته تو سایت نبود. پیشنهاد میکنم.',
  },
  {
    id: 9,
    name: "راضیه امیدی",
    comment: 'کرج- مهر 1402',
    text: 'اون بخشی که تابلو رو روی دیوار خونه خودم تونستم ببینم خیلی کمکم کرد. پیشنهاد میشه. تابلو هم رسید دستم خوب بود. من البته تابلو شب مهتابی آیوازفسکی رو گرفتم راضی بودم.',
  },
];


export default function CommentsSection() {
  return (
    <section
      dir="rtl"
      className="container my-12"
    >
      <h2 className="title">دیدگاه کاربران</h2>
      <Swiper
        modules={[Pagination]}
        spaceBetween={20}
        slidesPerView={4}
        pagination={{
          type: "bullets",
          clickable: true,
          bulletActiveClass: "!bg-black !opacity-100",
          renderBullet: (index, className) => {
            return `
              <span className="!size-2 ${className}"></span>
            `;
          },
        }}
        breakpoints={{
          0: {
            slidesPerView: 1,
          },
          640: {
            slidesPerView: 2,
          },
          1023: {
            slidesPerView: 3,
          },
          1400: {
            slidesPerView: 4,
          },
        }}
      >

        {comments.map((comment, i) => {
          return (
            <>
              <SwiperSlide
                key={i}
                dir="rtl"
                className="border p-4 lg:p-6 rounded-lg shadow-lg flex flex-col h-[21rem]"
              >
                <h3 className="mb-2 text-xl lg:text-2xl font-semibold">
                  {comment.name}
                </h3>
                <p className="mt-2 text-gray-700">{comment.comment}</p>
                <p className="text-justify mt-4 line-clamp-[8] flex-grow">{comment.text}</p>
              </SwiperSlide>
            </>
          )
        })}
      </Swiper>
    </section>
  );
};